import React from 'react';

import styles from './CarRentalSkeleton.module.scss';

interface CarRentalSkeletonProps {
  className?: string;
}

const CarRentalSkeleton: React.FC<CarRentalSkeletonProps> = ({ className }) => (
  <div className={`${styles.carRentalSkeleton} ${className || ''}`}>
    <div className={styles.skeletonCheckboxRow}>
      <div className={styles.skeletonCheckbox}></div>
      <div className={styles.skeletonCheckboxLabel}></div>
    </div>

    <div className={styles.skeletonFormContainer}>
      <div className={styles.skeletonLocationField}>
        <div className={styles.skeletonInput}></div>
      </div>

      <div className={styles.skeletonDateFields}>
        <div className={styles.skeletonDateField}>
          <div className={styles.skeletonDateText}></div>
          <div className={styles.skeletonTimeText}></div>
        </div>
        <div className={styles.skeletonDateField}>
          <div className={styles.skeletonDateText}></div>
          <div className={styles.skeletonTimeText}></div>
        </div>
      </div>

      <div className={styles.skeletonDriverSection}>
        <div className={styles.skeletonDriverCheckmark}></div>
        <div className={styles.skeletonDriverText}></div>
      </div>

      <div className={styles.skeletonCountrySection}>
        <div className={styles.skeletonCountryLabel}></div>
        <div className={styles.skeletonCountrySelector}></div>
      </div>

      <div className={styles.skeletonSearchButton}></div>
    </div>
  </div>
);

export default CarRentalSkeleton;
